import MUIAlert, { AlertColor } from '@mui/material/Alert';
import LoadingButton from 'atoms/LoadingButton';
import React, { useEffect, useState } from 'react';
import { useStore } from 'stores/store';
import { useUserAuth } from 'utils/hooks/useUserAuth';
import { navigateToUrl } from 'utils/navigateUtils';
import { Resources } from 'utils/resources';

import s from './Alert.module.scss';

const Alert = () => {
  const store = useStore();
  const authDetails = useUserAuth();

  const [alert, setAlert] = useState<{ message?: string; action?: string; severity?: AlertColor }>(
    {}
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const message =
      authDetails.isAuthenticated && !authDetails.isApproved
        ? !authDetails.investorAccredited
          ? Resources.ALERT_NOT_ACCREDITED
          : Resources.ALERT_COMPLETE_REGISTRATION
        : authDetails.isAuthenticated && !authDetails.emailVerified
        ? Resources.ALERT_EMAIL_NOT_VERIFIED
        : authDetails.investorPending
        ? Resources.ALERT_PENDING_SPONSOR
        : undefined;

    const action =
      authDetails.isAuthenticated && !authDetails.isApproved
        ? !authDetails.investorAccredited
          ? Resources.ALERT_NOT_ACCREDITED_ACTION
          : Resources.ALERT_COMPLETE_REGISTRATION_ACTION
        : authDetails.isAuthenticated && !authDetails.emailVerified
        ? Resources.ALERT_EMAIL_NOT_VERIFIED_ACTION
        : undefined;

    const severity =
      authDetails.isAuthenticated && !authDetails.isApproved
        ? 'warning'
        : authDetails.isAuthenticated && !authDetails.emailVerified
        ? 'warning'
        : authDetails.investorPending
        ? 'info'
        : 'warning';

    setAlert({ message, action, severity });
  }, [
    authDetails?.isAuthenticated,
    authDetails?.isApproved,
    authDetails?.emailVerified,
    authDetails?.investorPending,
    authDetails.investorAccredited
  ]);

  const redirectUser = async () => {
    if (!authDetails.investorAccredited && authDetails.kycDone) {
      return navigateToUrl('/profile/financial');
    }
    return navigateToUrl('/connect/welcome');
  };

  const onAction = async () => {
    setLoading(true);
    if (authDetails.isAuthenticated && !authDetails.isApproved) {
      await redirectUser();
    } else if (authDetails.isAuthenticated && !authDetails.emailVerified) {
      await store.ProfileStore.sendVerifyEmail();

      setAlert({
        message: Resources.ALERT_EMAIL_WAS_RESENT.replace('{email}', authDetails?.email ?? ''),
        action: Resources.ALERT_EMAIL_LETS_RESEND
      });
    }
    setLoading(false);
  };

  if (!alert?.message) {
    return null;
  }

  return (
    <MUIAlert
      className={s.Alert}
      severity={alert?.severity || 'warning'}
      variant="filled"
      sx={{ borderRadius: 0 }}
    >
      <span className={s.Alert__message}>{alert?.message}</span>
      {alert?.action && (
        <LoadingButton
          loading={loading}
          size="small"
          onClick={onAction}
          sx={{ color: 'inherit', lineHeight: 'inherit' }}
          variant="text"
        >
          {alert?.action}
        </LoadingButton>
      )}
    </MUIAlert>
  );
};

export default Alert;
